module.exports = __webpack_public_path__ + "img/docx.865987cc.png";